import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { ModeloConstancia } from '../models/modeloConstancia';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

const baseUrl = environment.hostService + '/ModeloConstancia';

@Injectable({
  providedIn: 'root'
})
export class ModeloConstanciaService {

  constructor(private _http: HttpClientService,
              private http: HttpClient) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  save(modelo: ModeloConstancia)
  {
    return this._http.post({ url: baseUrl + '/Save', body: modelo });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }

  Imprimir(modelo, legajo, sociedad, sede, subsede, fecha, firma): Observable<any>
  {
    return this.http.get(baseUrl + '/Imprimir?modelo=' + modelo + '&legajo=' + legajo 
    + '&sociedad=' + sociedad
    + '&sede=' + sede
    + '&subsede=' + subsede
    + '&fecha=' + fecha
    + '&firma=' + firma,{ responseType: 'blob' })
  }
}

